import { render, staticRenderFns } from "./CriarDadoModal.vue?vue&type=template&id=ca630df8&scoped=true"
import script from "./CriarDadoModal.vue?vue&type=script&setup=true&lang=js"
export * from "./CriarDadoModal.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca630df8",
  null
  
)

export default component.exports